module.exports = __webpack_public_path__ + "0de48cc3ddfa3d28cf4b5ba0858ad78e.png";